import useTranslation from 'next-translate/useTranslation';
import React, { Fragment } from 'react';
import { ManufacturerCountry } from 'types/ManufacturerCountry';
import { SelectItem } from '../CategoryFilter.styled';

type Props = {
  countries: ManufacturerCountry[];
  selectedCountry: number | null;
  setSelectedCountry: React.Dispatch<React.SetStateAction<number | null>>;
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
};

export default React.memo(function GeneralFilter({
  countries,
  selectedCountry,
  setSelectedCountry,
  setCurrent,
}: Props) {
  const { t } = useTranslation('common');
  const countriesOptions = countries.map((country) => ({
    label: country.name,
    value: country.id,
  }));
  return (
    <Fragment>
      <SelectItem
        placeholder={t('manufacturer_country')}
        value={countriesOptions.find((country) => country.value === selectedCountry) || null}
        options={countriesOptions}
        isClearable
        onChange={(option: any) => {
          setSelectedCountry(option?.value || null);
          setCurrent(1);
        }}
      />
      {/* <SelectItem
        placeholder={t('select-brand')}
        value={brandOptions.find((brand) => brand.value === selectedBrand) || null}
        options={brandOptions}
        onChange={(option: any) => {
          setSelectedBrand(option.value);
          setCurrent(1);
        }}
      /> */}
    </Fragment>
  );
});
